import { Product } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';

// eslint-disable-next-line import/prefer-default-export
export const updateProductList = (
  products: Product[],
  productToAdd: Product
): Product[] => {
  if (!products.length) {
    return [productToAdd];
  }

  const uniqueId = productToAdd.productApplicationId || productToAdd.id;
  const index = products.findIndex(
    p => (p.productApplicationId || p.id) === uniqueId
  );

  if (index !== -1) {
    const updated = [...products];
    updated[index] = productToAdd;
    return updated;
  }

  return [...products, productToAdd];
};
